


























import { Component, Vue, Prop } from 'vue-property-decorator';

import Stat from './partials/Stat.vue';
import { footballIcon, redCardIcon, yellowCardIcon, footballAssistIcon } from '@/assets/images';

@Component({
  components: { Stat }
})
export default class FutsalStats extends Vue {
  @Prop() private data!: any;

  get goalsStats() {
    return {
      title: 'Goals',
      icon: footballIcon,
      players: this.data.stats.goals
    };
  }

  get assistsStats() {
    return {
      title: 'Assists',
      icon: footballAssistIcon,
      players: this.data.stats.assists || []
    };
  }

  get yellowCardsStats() {
    return {
      title: 'Yellow Cards',
      icon: yellowCardIcon,
      players: this.data.stats.yellowCards
    };
  }

  get redCardsStats() {
    return {
      title: 'Red Cards',
      icon: redCardIcon,
      players: this.data.stats.redCards
    };
  }
}
